import { Component, Input } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { removeBackslash } from 'src/_lib/pipes/removebackslash.pipe';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { environment } from 'src/environments/environment.prod';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-category',
  templateUrl: './sub-category.component.html',
  styleUrls: ['./sub-category.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, removeBackslash]
})

export class SubCategoryComponent {
  category_key: number = 0;
  category_name: string = '';
  cdnImagePath: string = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;

  @Input() subCategoryData: any[] = [];
  @Input() displaySettings: any;
  @Input() FilterRedirectionData: any;

  constructor(
    private commonService: CommanpageService,
    private router:Router
  ) { }

  get normalizedDisplaySettings() {
    return Array.isArray(this.displaySettings) ? this.displaySettings[0] : this.displaySettings || { category_view: 'thumbnail' };
  }

  subCategoriesRedirection(event: any): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.commonService.categoryRedirection(event.category_name, event.category_key);
  }

  onSubcategoryImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = `${this.commonImagePath}image_not_found.webp`;
  }

  get categoryView(): string {
    const view = this.normalizedDisplaySettings?.category_view;
    if (view === 'button' || view === 'button_side_filters') {
      return 'button';
    }
    return 'thumbnail';
  }

  get showTopCategories(): boolean {
    const view = this.normalizedDisplaySettings?.category_view;
    return [
      'thumbnail',
      'button',
      'thumbnail_side_filters',
      'button_side_filters'
    ].includes(view);
  }
}